import { render, staticRenderFns } from "./ScalarValue.vue?vue&type=template&id=59fe5c40"
import script from "./ScalarValue.vue?vue&type=script&lang=js"
export * from "./ScalarValue.vue?vue&type=script&lang=js"
import style0 from "./ScalarValue.vue?vue&type=style&index=0&id=59fe5c40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports